<template>
  <div class="viewer-layout-root">
    <slot />
  </div>
</template>

<style scoped>
.viewer-layout-root {
  @apply flex flex-col w-full pt-12 sm:pt-6;
}
</style>
